<template>
  <div>
    <Breadcrumbs :items="items" />

    <v-sheet class="transparent-background-color">
      <v-row dense class="mx-5">
        <v-col cols="12" sm="6" md="4">
          <v-row dense align="center" class="pa-1">
            <SearcherKeyword
              ref="keyword"
              v-model="options.keyword"
              @text="materialKeyword = $event"
              :label="$t('StockMaterials.materialKeyword')"
            />
          </v-row>
        </v-col>
        <v-col cols="12" sm="12" md="8" align-self="center">
          <v-row dense align="center" class="search-controls">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-bind="attrs"
                  v-on="on"
                  small
                  text
                  class="px-0 py-0 caption font-weight-bold grey--text"
                  color="primary"
                  @click.stop="onSearch()"
                >
                  <v-icon small class="pe-1">fa-search</v-icon>
                  {{ $t("Search.search") }}
                </v-btn>
              </template>
              <span>{{ $t("Search.searchTip") }}</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-bind="attrs"
                  v-on="on"
                  small
                  text
                  class="caption font-weight-bold grey--text"
                  @click.stop="resetSearch()"
                >
                  <v-icon x-small class="pe-1">fa-trash-alt</v-icon>
                  {{ $t("Search.reset") }}
                </v-btn>
              </template>
              <span>{{ $t("Search.resetTip") }}</span>
            </v-tooltip>
            <v-spacer />
            <v-btn
              v-if="!settings.is_ban_add_stock_materials"
              small
              dark
              color="action"
              @click.stop="selectMaterialsDialog = true"
              class="ms-1"
            >
              <v-icon x-small class="pe-1">fa-plus</v-icon>
              {{ $t("CRUD.chooseInfo", [$t("Material.ObjectName")]) }}
            </v-btn>
            <v-btn
              v-if="$permission.permissionAllow('StockMaterials', 'import')"
              small
              color="print"
              dark
              class="ms-1"
              @click.stop="ImportDialog = true"
            >
              <v-icon x-small class="px-1">fa-file-import</v-icon>
              {{ $t("Import.import", []) }}
            </v-btn>
            <v-btn
              v-if="$permission.permissionAllow('StockMaterials', 'export')"
              small
              color="print"
              dark
              class="ms-1"
              @click.stop="exportExcel()"
            >
              <v-icon x-small class="px-1">fa-file-export</v-icon>
              {{ $t("Export.export", []) }}
            </v-btn>
            <v-btn small color="success" @click="submit()" class="ms-1">
              <v-icon x-small class="pe-1">fa-save</v-icon>
              {{ $t("CRUD.save") }}
            </v-btn>
          </v-row>
        </v-col>
      </v-row>
      <v-row dense align="center" class="mx-5">
        <v-col cols="12" sm="6" md="4" align-self="center">
          <v-row dense align="center" class="pa-1">
            <SearcherMaterialCategoriesWithDescendants
              v-model="categorySelecteds"
            />
          </v-row>
        </v-col>
        <v-col
          cols="12"
          sm="6"
          md="4"
          v-if="
            settings &&
            settings.stock_position_setting &&
            (isWMS == 1 || isWMS == 3)
          "
        >
          <v-row dense align="center" class="pa-1">
            <SearcherArea v-model="stockAreaSelected" :stock-id="stock_id" />
          </v-row>
        </v-col>
        <v-col
          cols="12"
          sm="6"
          md="4"
          v-if="settings && settings.stock_position_setting && isWMS == 3"
        >
          <v-row dense align="center" class="pa-1">
            <SearcherStockPosition
              v-model="positionSelected"
              :stockId="stock_id"
            />
          </v-row>
        </v-col>
        <v-col cols="12" sm="6" md="4">
          <div
            class="caption grey--text input-chip-group-label"
            :class="$vuetify.theme.dark ? 'text--lighten-1' : 'text--darken-1'"
          >
            {{ $t("Material.deleteFlgs.title") }}
          </div>
          <v-chip-group
            v-model="options.material_delete_flg"
            column
            multiple
            class="mx-1"
          >
            <v-chip
              small
              label
              filter
              class="mx-1"
              color="primary"
              text-color="white"
              :key="0"
              :value="0"
              >{{ $t("Material.deleteFlgs.off") }}</v-chip
            >
            <v-chip
              small
              label
              filter
              class="mx-1"
              color="grey"
              text-color="white"
              :key="1"
              :value="1"
              >{{ $t("Material.deleteFlgs.on") }}</v-chip
            >
          </v-chip-group>
        </v-col>
        <v-col cols="12" sm="6" md="4">
          <div
            class="caption grey--text input-chip-group-label"
            :class="$vuetify.theme.dark ? 'text--lighten-1' : 'text--darken-1'"
          >
            {{ $t("StockMaterials.statusFlgs.title") }}
          </div>
          <v-chip-group v-model="options.status" column multiple class="mx-1">
            <v-chip
              small
              label
              filter
              class="mx-1"
              color="primary"
              text-color="white"
              :key="1"
              :value="1"
              >{{ $t("StockMaterials.statusFlgs.on") }}</v-chip
            >
            <v-chip
              small
              label
              filter
              class="mx-1"
              color="grey"
              text-color="white"
              :key="0"
              :value="0"
              >{{ $t("StockMaterials.statusFlgs.off") }}</v-chip
            >
          </v-chip-group>
        </v-col>
        <v-col cols="12" sm="6" md="4" v-if="isWMS == 1 || isWMS == 3">
          <div
            class="caption grey--text input-chip-group-label"
            :class="$vuetify.theme.dark ? 'text--lighten-1' : 'text--darken-1'"
          >
            {{ $t("StockMaterials.prohibitFlgs.title") }}
          </div>
          <v-chip-group
            v-model="options.prohibit_flg"
            column
            multiple
            class="mx-1"
          >
            <v-chip
              small
              label
              filter
              class="mx-1"
              color="primary"
              text-color="white"
              :key="1"
              :value="1"
              >{{ $t("StockMaterials.prohibitFlgs.on") }}</v-chip
            >
            <v-chip
              small
              label
              filter
              class="mx-1"
              color="grey"
              text-color="white"
              :key="0"
              :value="0"
              >{{ $t("StockMaterials.prohibitFlgs.off") }}</v-chip
            >
          </v-chip-group>
        </v-col>
        <v-col cols="12" sm="6" md="4" v-if="isWMS == 2 || isWMS == 3">
          <div
            class="caption grey--text input-chip-group-label"
            :class="$vuetify.theme.dark ? 'text--lighten-1' : 'text--darken-1'"
          >
            {{ $t("StockMaterials.isNegativeAllowedFlgs.title") }}
          </div>
          <v-chip-group
            v-model="options.is_negative_allowed"
            column
            multiple
            class="mx-1"
          >
            <v-chip
              small
              label
              filter
              class="mx-1"
              color="primary"
              text-color="white"
              :key="1"
              :value="1"
              >{{ $t("StockMaterials.isNegativeAllowedFlgs.on") }}</v-chip
            >
            <v-chip
              small
              label
              filter
              class="mx-1"
              color="grey"
              text-color="white"
              :key="0"
              :value="0"
              >{{ $t("StockMaterials.isNegativeAllowedFlgs.off") }}</v-chip
            >
          </v-chip-group>
        </v-col>
      </v-row>

      <div class="mx-4 mb-4">
        <v-data-table
          :headers="headers"
          :items="stock_materials"
          :expanded.sync="expandItems"
          :loading="loading"
          :options.sync="options"
          :page.sync="paging.page"
          :server-items-length="paging.count"
          multi-sort
          class="elevation-1 px-4 pt-1"
          :footer-props="footerProps"
        >
          <template v-slot:body.prepend>
            <tr class="d-none d-sm-table-row">
              <td :colspan="isWMS == 1 ? '8' : isWMS == 3 ? '9' : '6'"></td>
              <td class="align-center">
                <v-checkbox
                  v-if="isWMS == 1 || isWMS == 3"
                  class="mt-2 mb-n2"
                  color="primary"
                  :indeterminate="
                    stock_materials.find(
                      (detail) => detail.prohibit_flg != prohibitAll
                    )
                      ? true
                      : false
                  "
                  v-model="prohibitAll"
                  :true-value="1"
                  :false-value="0"
                >
                  <template v-slot:label>
                    <span class="caption ms-n2">
                      {{ $t("StockMaterials.thisPage")
                      }}{{ $t("StockMaterials.blockAll") }}
                    </span>
                  </template>
                </v-checkbox>
                <v-checkbox
                  v-else-if="isWMS == 2"
                  class="mt-2 mb-n2"
                  color="primary"
                  :indeterminate="
                    stock_materials.find(
                      (detail) => detail.is_negative_allowed != underZeroAll
                    )
                      ? true
                      : false
                  "
                  v-model="underZeroAll"
                  :true-value="1"
                  :false-value="0"
                >
                  <template v-slot:label>
                    <span class="caption ms-n2">
                      {{ $t("StockMaterials.thisPage")
                      }}{{ $t("StockMaterials.underZeroAll") }}
                    </span>
                  </template>
                </v-checkbox>
              </td>
              <td v-if="isWMS == 3">
                <v-checkbox
                  class="mt-2 mb-n2"
                  color="primary"
                  :indeterminate="
                    stock_materials.find(
                      (detail) => detail.is_negative_allowed != underZeroAll
                    )
                      ? true
                      : false
                  "
                  v-model="underZeroAll"
                  :true-value="1"
                  :false-value="0"
                >
                  <template v-slot:label>
                    <span class="caption ms-n2">
                      {{ $t("StockMaterials.thisPage")
                      }}{{ $t("StockMaterials.underZeroAll") }}
                    </span>
                  </template>
                </v-checkbox>
              </td>
              <td></td>
              <td class="align-center">
                <v-checkbox
                  class="mt-2 mb-n2"
                  color="primary"
                  :indeterminate="
                    stock_materials.find((detail) => detail.status != usableAll)
                      ? true
                      : false
                  "
                  v-model="usableAll"
                  :true-value="1"
                  :false-value="0"
                >
                  <template v-slot:label>
                    <span class="caption ms-n2">
                      {{ $t("StockMaterials.thisPage")
                      }}{{ $t("StockMaterials.usableAll") }}
                    </span>
                  </template>
                </v-checkbox>
              </td>
              <td></td>
            </tr>
            <tr class="d-table-row d-sm-none">
              <td class="v-data-table__mobile-row">
                <div class="v-data-table__mobile-row__header mt-1">
                  {{ $t("StockMaterials.thisPage") }}
                  {{
                    isWMS == 1 || isWMS == 3
                      ? $t("StockMaterials.blockAll")
                      : isWMS == 2
                      ? $t("StockMaterials.underZeroAll")
                      : ""
                  }}
                </div>
                <div class="v-data-table__mobile-row__cell mt-1">
                  <v-checkbox
                    v-if="isWMS == 1 || isWMS == 3"
                    class="mt-2 mb-n2"
                    color="primary"
                    :indeterminate="
                      stock_materials.find(
                        (detail) => detail.prohibit_flg != prohibitAll
                      )
                        ? true
                        : false
                    "
                    v-model="prohibitAll"
                    :true-value="1"
                    :false-value="0"
                  >
                  </v-checkbox>
                  <v-checkbox
                    v-else-if="isWMS == 2"
                    class="mt-2 mb-n2"
                    color="primary"
                    :indeterminate="
                      stock_materials.find(
                        (detail) => detail.is_negative_allowed != underZeroAll
                      )
                        ? true
                        : false
                    "
                    v-model="underZeroAll"
                    :true-value="1"
                    :false-value="0"
                  >
                  </v-checkbox>
                </div>
              </td>
              <td class="v-data-table__mobile-row" v-if="isWMS == 3">
                <div class="v-data-table__mobile-row__header mt-1">
                  {{ $t("StockMaterials.thisPage") }}
                  {{ $t("StockMaterials.underZeroAll") }}
                </div>
                <div class="v-data-table__mobile-row__cell mt-1">
                  <v-checkbox
                    class="mt-2 mb-n2"
                    color="primary"
                    :indeterminate="
                      stock_materials.find(
                        (detail) => detail.is_negative_allowed != underZeroAll
                      )
                        ? true
                        : false
                    "
                    v-model="underZeroAll"
                    :true-value="1"
                    :false-value="0"
                  >
                  </v-checkbox>
                </div>
              </td>
              <td class="v-data-table__mobile-row">
                <div class="v-data-table__mobile-row__header mt-1">
                  {{ $t("StockMaterials.usableAll") }}
                </div>
                <div class="v-data-table__mobile-row__cell mt-1">
                  <v-checkbox
                    class="mt-2 mb-n2"
                    color="primary"
                    :indeterminate="
                      stock_materials.find(
                        (detail) => detail.status != usableAll
                      )
                        ? true
                        : false
                    "
                    v-model="usableAll"
                    :true-value="1"
                    :false-value="0"
                  >
                  </v-checkbox>
                </div>
              </td>
            </tr>
          </template>
          <template v-slot:header.unit="{ header }">
            {{ header.text }}
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  small
                  v-bind="attrs"
                  v-on="on"
                  color="primary"
                  class="px-1 me-1"
                  @click.stop="
                    confirmMsg = $t('StockMaterials.alertMessage', [
                      $t('StockMaterials.batchUpdateUnit.asc'),
                    ]);
                    confirmDialog = true;
                    confirmType = 'batchUpdateUnitAsc';
                  "
                >
                  fa-arrow-down
                </v-icon>
              </template>
              <span>
                {{ $t("StockMaterials.batchUpdateUnit.asc") }}
              </span>
            </v-tooltip>
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  small
                  v-bind="attrs"
                  v-on="on"
                  color="primary"
                  class="px-1 me-1"
                  @click.stop="
                    confirmMsg = $t('StockMaterials.alertMessage', [
                      $t('StockMaterials.batchUpdateUnit.desc'),
                    ]);
                    confirmDialog = true;
                    confirmType = 'batchUpdateUnitDesc';
                  "
                >
                  fa-arrow-up
                </v-icon>
              </template>
              <span>
                {{ $t("StockMaterials.batchUpdateUnit.desc") }}
              </span>
            </v-tooltip>
          </template>
          <template v-slot:header.is_negative_allowed="{ header }">
            {{ header.text }}
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  small
                  v-bind="attrs"
                  v-on="on"
                  color="primary"
                  class="px-1 me-1"
                  @click.stop="
                    confirmMsg = $t('StockMaterials.alertMessage', [
                      $t('StockMaterials.isNegativeAllowedFlgs.onAll'),
                    ]);
                    confirmDialog = true;
                    confirmType = 'negativeAllowedOnAll';
                  "
                >
                  fa-check
                </v-icon>
              </template>
              <span>
                {{ $t("StockMaterials.isNegativeAllowedFlgs.onAll") }}
              </span>
            </v-tooltip>
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  small
                  v-bind="attrs"
                  v-on="on"
                  color="primary"
                  class="px-1 me-1"
                  @click.stop="
                    confirmMsg = $t('StockMaterials.alertMessage', [
                      $t('StockMaterials.isNegativeAllowedFlgs.offAll'),
                    ]);
                    confirmDialog = true;
                    confirmType = 'negativeAllowedOffAll';
                  "
                >
                  fa-times
                </v-icon>
              </template>
              <span>
                {{ $t("StockMaterials.isNegativeAllowedFlgs.offAll") }}
              </span>
            </v-tooltip>
          </template>
          <template v-slot:header.status="{ header }">
            {{ header.text }}
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  small
                  v-bind="attrs"
                  v-on="on"
                  color="primary"
                  class="px-1 me-1"
                  @click.stop="
                    confirmMsg = $t('StockMaterials.alertMessage', [
                      $t('StockMaterials.statusFlgs.onAll'),
                    ]);
                    confirmDialog = true;
                    confirmType = 'statusFlgOnAll';
                  "
                >
                  fa-check
                </v-icon>
              </template>
              <span>
                {{ $t("StockMaterials.statusFlgs.onAll") }}
              </span>
            </v-tooltip>
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  small
                  v-bind="attrs"
                  v-on="on"
                  color="primary"
                  class="px-1 me-1"
                  @click.stop="
                    confirmMsg = $t('StockMaterials.alertMessage', [
                      $t('StockMaterials.statusFlgs.offAll'),
                    ]);
                    confirmDialog = true;
                    confirmType = 'statusFlgOffAll';
                  "
                >
                  fa-times
                </v-icon>
              </template>
              <span>
                {{ $t("StockMaterials.statusFlgs.offAll") }}
              </span>
            </v-tooltip>
          </template>
          <template v-slot:item.material_name="{ item }">
            <span>
              {{ item.material_name }}
            </span>
            <br />
            <span class="caption secondary--text">
              {{ $t("Material.Fields.standard") }}{{ $t("Global.colon")}}
              <span v-if="item.standard_name && item.standard_name.length > 12" :title="item.standard_name" style="cursor: pointer">
                {{ item.standard_name.slice(0, 12) + "......" }}
              </span>
              <span v-else>
                {{ item.standard_name }}
              </span>
            </span>
          </template>
          <template v-slot:item.current_count="{ item }">
            <span v-if="$i18n.locale == 'zhHans'">
              {{ item.stock_num }}
            </span>
            <span v-else>
              <span class="text-no-wrap caption font-weight-bold">
                {{ item.stock_single_unit_num }}
              </span>
              <br />
              <span class="text-no-wrap caption secondary--text">
                {{ item.unit }}
              </span>
            </span>
          </template>
          <template v-slot:item.unit="{ item }">
            <span v-if="item.edit_flg">
              <v-select
                v-model="item.standard_detail_id"
                :items="item.standard.standard_details"
                item-text="unit"
                item-value="id"
                style="max-width: 60px; margin-left: auto"
                single-line
                dense
                hide-details
              />
            </span>
            <span v-else>
              {{ item.unit }}
            </span>
          </template>
          <template v-slot:item.stock_max="{ item }">
            <v-row dense class="my-3">
              <v-col class="mt-3">
                <span class="pt-n1 text-no-wrap caption">
                  {{ $t("StockMaterials.Fields.max_num") + $t("Global.colon") }}
                </span>
              </v-col>
              <v-col>
                <v-text-field
                  single-line
                  dense
                  hide-details
                  v-model="item.stock_max"
                  type="number"
                  min="0"
                  class="input-center"
                  @blur="
                    item.stock_max = $numberFormatter.formatWithDotNoMoreThan(
                      item.stock_max,
                      2
                    )
                  "
                  style="max-width: 60px; margin-left: auto"
                  :disabled="item.edit_flg ? false : true"
                >
                </v-text-field>
              </v-col>
            </v-row>
            <v-row dense class="my-3">
              <v-col class="mt-3">
                <span class="pt-n1 text-no-wrap caption">
                  {{ $t("StockMaterials.Fields.min_num") + $t("Global.colon") }}
                </span>
              </v-col>
              <v-col>
                <v-text-field
                  single-line
                  dense
                  hide-details
                  v-model="item.stock_min"
                  type="number"
                  min="0"
                  class="input-center"
                  @blur="
                    item.stock_min = $numberFormatter.formatWithDotNoMoreThan(
                      item.stock_min,
                      2
                    )
                  "
                  style="max-width: 60px; margin-left: auto"
                  :disabled="item.edit_flg ? false : true"
                />
              </v-col>
            </v-row>
          </template>
          <template v-slot:item.pick_max="{ item }">
            <v-row dense class="my-3">
              <v-col class="mt-3">
                <span class="pt-n1 text-no-wrap caption">
                  {{ $t("StockMaterials.Fields.max_num") + $t("Global.colon") }}
                </span>
              </v-col>
              <v-col>
                <v-text-field
                  single-line
                  dense
                  hide-details
                  v-model="item.pick_max"
                  type="number"
                  min="0"
                  class="input-center"
                  @blur="
                    item.pick_max = $numberFormatter.formatWithDotNoMoreThan(
                      item.pick_max,
                      2
                    )
                  "
                  style="max-width: 60px; margin-left: auto"
                  :disabled="item.edit_flg ? false : true"
                >
                </v-text-field>
              </v-col>
            </v-row>
            <v-row dense class="my-3">
              <v-col class="mt-3">
                <span class="pt-n1 text-no-wrap caption">
                  {{ $t("StockMaterials.Fields.min_num") + $t("Global.colon") }}
                </span>
              </v-col>
              <v-text-field
                single-line
                dense
                hide-details
                v-model="item.pick_min"
                type="number"
                min="0"
                class="input-center"
                @blur="
                  item.pick_min = $numberFormatter.formatWithDotNoMoreThan(
                    item.pick_min,
                    2
                  )
                "
                style="max-width: 60px; margin-left: auto"
                :disabled="item.edit_flg ? false : true"
              />
            </v-row>
          </template>
          <template v-slot:item.peeling="{ item }">
            <v-text-field
              single-line
              dense
              hide-details
              v-model="item.peeling"
              type="number"
              min="0"
              class="input-center"
              @blur="
                item.peeling = $numberFormatter.formatWithDotNoMoreThan(
                  item.peeling,
                  2
                )
              "
              style="max-width: 60px; margin-left: auto"
              :disabled="item.edit_flg ? false : true"
              v-if="
                weightUnit.indexOf(
                  item.standard.standard_details.find(
                    (detail) => detail.id == item.standard_detail_id
                  ).unit
                ) > -1
              "
            >
            </v-text-field>
          </template>
          <template v-slot:item.stock_area.name="{ item }">
            <SearcherArea
              v-if="item.edit_flg"
              v-model="item.stock_area"
              :stock-id="Number(stock_id)"
              noLabel
              style="max-width: 180px; margin-left: auto"
              unclearable
            />
            <span v-else>
              {{ item.stock_area ? item.stock_area.area_name : "" }}
            </span>
          </template>
          <template v-slot:item.stock_position="{ item }">
            <SearcherStockPosition
              v-if="item.edit_flg"
              v-model="item.stock_position"
              :stockId="Number(stock_id)"
              noLabel
              :stockAreaSetting="true"
              :stockAreaId="item.stock_area ? item.stock_area.id : -1"
            />
            <span v-else>
              {{ item.stock_position ? item.stock_position.position_name : "" }}
            </span>
          </template>
          <!-- wms:是否冻结 -->
          <template v-slot:item.prohibit_flg="{ item }">
            <div class="d-flex mt-n2 mb-n3">
              <v-checkbox
                color="primary"
                v-model="item.prohibit_flg"
                :true-value="1"
                :false-value="0"
                :disabled="item.edit_flg ? false : true"
              >
                <template v-slot:label>
                  <span class="caption ms-n2">
                    {{
                      $t(
                        item.prohibit_flg
                          ? "StockMaterials.Fields.block_on"
                          : "StockMaterials.Fields.block_off"
                      )
                    }}
                  </span>
                </template>
              </v-checkbox>
            </div>
          </template>
          <!-- 无wms:是否可负库存 -->
          <template v-slot:item.is_negative_allowed="{ item }">
            <div class="d-flex mt-n2 mb-n3">
              <v-checkbox
                color="primary"
                v-model="item.is_negative_allowed"
                :true-value="1"
                :false-value="0"
                :disabled="item.edit_flg ? false : true"
              >
                <template v-slot:label>
                  <span class="caption ms-n2">
                    {{
                      $t(
                        item.is_negative_allowed
                          ? "StockMaterials.Fields.under_zero_on"
                          : "StockMaterials.Fields.under_zero_off"
                      )
                    }}
                  </span>
                </template>
              </v-checkbox>
            </div>
          </template>
          <template v-slot:item.status="{ item }">
            <div class="d-flex mt-n2 mb-n3">
              <v-checkbox
                color="primary"
                v-model="item.status"
                :true-value="1"
                :false-value="0"
                :disabled="item.edit_flg ? false : true"
              >
                <template v-slot:label>
                  <span class="caption ms-n2">
                    {{
                      $t(
                        item.status
                          ? "StockMaterials.Fields.use_on"
                          : "StockMaterials.Fields.use_off"
                      )
                    }}
                  </span>
                </template>
              </v-checkbox>
            </div>
          </template>
          <template v-slot:item.actions="{ item }">
            <v-tooltip top v-if="!item.new">
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  small
                  v-bind="attrs"
                  v-on="on"
                  :color="item.edit_flg ? 'grey' : 'primary'"
                  class="px-1 me-1"
                  @click.stop="item.edit_flg ? '' : (item.edit_flg = true)"
                >
                  fa-pencil-alt
                </v-icon>
              </template>
              <span>
                {{ $t("CRUD.editInfo", [$t("Material.ObjectName")]) }}
              </span>
            </v-tooltip>
            <v-btn
              v-if="item.new"
              small
              text
              class="danger--text pa-0"
              @click.stop="
                stock_materials.splice(
                  stock_materials.findIndex((detail) => item.new == detail.new),
                  1
                )
              "
            >
              <v-icon>fa-times</v-icon>
            </v-btn>
          </template>
        </v-data-table>
      </div>
    </v-sheet>
    <MaterialsSelectsDialog
      v-model="selectMaterialsDialog"
      :materialIds="savedMaterialIdsArr"
      :disabledChoosed="true"
      @confirm="
        addMaterials = $event;
        options.page = 1;
        saveNewStockMaterials();
      "
    />
    <DialogAlert
      v-model="confirmDialog"
      :message="confirmMsg"
      useConfirm
      @confirm="allSave()"
    />
    <ImportExcelAlert
      v-model="ImportDialog"
      :objName="$t('StockMaterials.importObjName')"
      isHint
      :hintDetail="$t('StockMaterials.importHint')"
      hideDownload
      @import="
        excelFile = $event;
        importExcel();
      "
    />
  </div>
</template>

<script>
import { mapState } from "vuex";
import i18n from "@/i18n";
import Breadcrumbs from "@/components/Breadcrumbs";
import SearcherKeyword from "@/components/plugins/SearcherKeyword";
import SearcherMaterialCategoriesWithDescendants from "@/components/plugins/SearcherMaterialCategoriesWithDescendants";
import SearcherArea from "@/components/plugins/SearcherStockArea";
import MaterialsSelectsDialog from "@/components/plugins/MaterialsSelectsDialog";
// import SearcherStatus from "@/components/plugins/SearcherStatus";
import Stocks from "@/api/stocks";
import StockAreas from "@/api/stock_areas";
import StockMaterials from "@/api/stock_materials";
import DialogAlert from "@/components/plugins/DialogAlert";
import SearcherStockPosition from "@/components/plugins/SearcherStockPosition";
import ImportExcelAlert from "@/components/plugins/ImportExcelAlert";

export default {
  components: {
    Breadcrumbs,
    SearcherKeyword,
    SearcherMaterialCategoriesWithDescendants,
    MaterialsSelectsDialog,
    SearcherArea,
    DialogAlert,
    SearcherStockPosition,
    ImportExcelAlert,
    // SearcherStatus,
  },

  computed: {
    stock_id() {
      return this.$route.query.stock_id
        ? Number(this.$route.query.stock_id)
        : 0;
    },

    isWMS() {
      if (
        this.settings &&
        this.settings.stock_position_setting &&
        this.stock.wms_setting
      ) {
        return 1;
      } else if (
        this.settings &&
        this.settings.material_position_bind &&
        this.stock.simple_wms_setting
      ) {
        return 3;
      } else if (
        this.settings &&
        ((!this.settings.stock_position_setting && !this.stock.wms_setting) ||
          (this.settings.stock_position_setting && !this.stock.wms_setting))
      ) {
        return 2;
      } else {
        return 0;
      }
    },

    items() {
      return [
        {
          text: i18n.t("Nav.home"),
          disabled: false,
          href: "/home",
        },
        {
          text: i18n.t("Nav.stock"),
          disabled: false,
          href: "/stocks",
        },
        {
          text: i18n.t("Nav.stocks"),
          disabled: false,
          href: "/stocks",
        },
        {
          text: i18n.t("Nav.stockMaterials"),
          disabled: true,
          href: "/stocks/stock-materials",
        },
        {
          text: this.stock && this.stock.name ? this.stock.name : "",
          disabled: false,
          accent: true,
        },
      ];
    },

    headers() {
      var headers = [
        {
          text: i18n.t("StockMaterials.Fields.material_category"),
          align: "start",
          sortable: false,
          filterable: true,
          value: "category_name",
        },
        {
          text: i18n.t("StockMaterials.Fields.material_code"),
          align: "start",
          sortable: false,
          filterable: true,
          value: "material_code",
        },
        {
          text: i18n.t("StockMaterials.Fields.material"),
          align: "start",
          sortable: false,
          filterable: true,
          value: "material_name",
        },
        {
          text: i18n.t("StockMaterials.Fields.unit"),
          align: "center",
          sortable: false,
          filterable: false,
          value: "unit",
        },
        {
          text: i18n.t("StockMaterials.Fields.current_stock"),
          align: "end",
          sortable: false,
          filterable: false,
          value: "current_count",
        },
        {
          text: i18n.t("StockMaterials.Fields.stock_max_and_min_num"),
          align: "center",
          sortable: false,
          filterable: true,
          value: "stock_max",
        },
      ];
      //wms
      if (this.isWMS == 1) {
        headers.push(
          {
            text: i18n.t("StockMaterials.Fields.pick_position_max_and_min_num"),
            align: "end",
            sortable: false,
            filterable: true,
            value: "pick_max",
          },
          {
            text: i18n.t("StockMaterials.Fields.stock_area"),
            align: "center",
            sortable: false,
            filterable: true,
            value: "stock_area.name",
          },
          {
            text: i18n.t("StockMaterials.Fields.material_block"),
            align: "start",
            sortable: false,
            filterable: true,
            value: "prohibit_flg",
          }
        );
      } else if (this.isWMS == 2) {
        //无wms
        headers.push({
          text: i18n.t("StockMaterials.Fields.under_zero_stock_num"),
          align: "start",
          sortable: false,
          filterable: true,
          value: "is_negative_allowed",
        });
      }
      if (this.isWMS == 3) {
        headers.push(
          {
            text: i18n.t("StockMaterials.Fields.pick_position_max_and_min_num"),
            align: "end",
            sortable: false,
            filterable: true,
            value: "pick_max",
          },
          {
            text: i18n.t("StockMaterials.Fields.stock_area"),
            align: "center",
            sortable: false,
            filterable: true,
            value: "stock_area.name",
          },
          {
            text: i18n.t("StockMaterials.Fields.stock_position"),
            align: "center",
            sortable: false,
            filterable: true,
            value: "stock_position",
          },
          {
            text: i18n.t("StockMaterials.Fields.material_block"),
            align: "start",
            sortable: false,
            filterable: true,
            value: "prohibit_flg",
          },
          {
            text: i18n.t("StockMaterials.Fields.under_zero_stock_num"),
            align: "start",
            sortable: false,
            filterable: true,
            value: "is_negative_allowed",
          }
        );
      }

      headers.push(
        {
          text: i18n.t("StockMaterials.Fields.peeling"),
          align: "start",
          sortable: false,
          filterable: false,
          value: "peeling",
        },
        {
          text: i18n.t("StockMaterials.Fields.usable"),
          align: "start",
          sortable: false,
          filterable: false,
          value: "status",
        },
        {
          text: i18n.t("TableHeaders.actions"),
          align: "start",
          sortable: false,
          value: "actions",
        }
      );

      return headers;
    },
    footerProps() {
      var props = i18n.t("$config.footer-props");
      props.itemsPerPageOptions.push(-1);
      return props;
    },

    // stockMaterialItems() {
    //   return this.stock_materials.map((material) => {
    //     material.Description = i18n.t(
    //       this.settings
    //         ? this.settings.material_name_display_type == 3
    //           ? "Material.materialNameWithCodeAndStandard"
    //           : this.settings.material_name_display_type == 2
    //           ? "Material.materialNameWithCode"
    //           : "Material.materialName"
    //         : "Material.materialName",
    //       [
    //         material.material_code,
    //         material.material_name,
    //         material.standard_name,
    //       ]
    //     );

    //     //换算当前库存量
    //     if (material.standard_detail.rate > 1) {
    //       var num_rate = parseInt(
    //         material.current_count / material.standard_detail.rate
    //       );
    //       material.current_num_with_unit = num_rate + material.unit;
    //       if (material.current_count % material.standard_detail.rate) {
    //         var num_default = parseFloat(
    //           material.current_count % material.standard_detail.rate
    //         ).toFixed(2);
    //         material.current_num_with_unit +=
    //           num_default + material.default_standard_detail.unit;
    //       }
    //       //换算成小数形式，匹配外语显示
    //       material.current_num_rate = parseFloat(
    //         material.current_count / material.standard_detail.rate
    //       ).toFixed(2);
    //     } else {
    //       material.current_num_with_unit =
    //         this.$numberFormatter.formatTwoDot(material.current_count) +
    //         material.unit;
    //     }

    //     return material;
    //   });
    // },

    // 使用对象展开运算符将此对象混入到外部对象中
    ...mapState(["loading", "settings"]),
  },

  data: () => ({
    stock: {},
    stockAreaSelected: null,
    stock_materials: [],
    changedDetails: [],
    materialKeyword: "",
    categorySelecteds: [],
    options: {
      keyword: "",
      category_codes: [],
      material_delete_flg: [0],
      stock_area_ids: [],
      status: [1],
      prohibit_flg: [1],
      stock_position_id: null,
      is_negative_allowed: [1],
    },
    usableAll: 1,
    prohibitAll: 0,
    underZeroAll: 1,
    addMaterials: [],
    expandItems: [],
    lastPriceFor: null,
    selectMaterialsDialog: false,
    ImportDialog: false,
    excelFile: null,
    materialIdsArr: [],
    paging: {},
    confirmDialog: false,
    confirmMsg: "",
    confirmType: null,
    savedMaterialIdsArr: [],
    positionSelected: null,
    weightUnit: [],
  }),

  mounted() {
    //获取仓库信息
    Stocks.fetchOne(this.stock_id).then(
      function (response) {
        if (response.data.status.isOK()) {
          this.stock = response.data.stock;
        }
      }.bind(this)
    );
    //获取库区列表
    StockAreas.fetchAllForSelect({ stock_id: this.stock_id }).then(
      function (response) {
        if (response.data.status.isOK()) {
          this.stock_areas = response.data.stock_areas;
        }
      }.bind(this)
    );

    this.getStockMaterialsFromAPI();
  },

  methods: {
    resetSearch() {
      this.categorySelecteds = [];
      this.stockAreaSelected = null;
      this.positionSelected = null;
      this.options = {
        keyword: "",
        category_codes: [],
        material_delete_flg: [0],
        stock_area_ids: [],
        status: [1],
        prohibit_flg: [1],
        stock_position_id: null,
        is_negative_allowed: [1],
      };
      [this.$refs.keyword].forEach((k) => {
        if (k) k.clear();
      });
    },
    onSearch() {
      this.options = Object.assign({}, this.options, {
        keyword: this.materialKeyword,
      });
    },
    //获取仓库商品列表
    getStockMaterialsFromAPI() {
      var options = {
        stock_id: this.stock_id,
        readonly: 0,
      };
      if (this.isWMS == 1) {
        //wms
        for (let key in this.options) {
          if (key != "is_negative_allowed") {
            options[key] = this.options[key];
          }
        }
      } else if (this.isWMS == 2) {
        //无wms
        for (let key in this.options) {
          if (key != "prohibit_flg") {
            options[key] = this.options[key];
          }
        }
      }
      if (this.isWMS == 3) {
        for (let key in this.options) {
          options[key] = this.options[key];
        }
      }
      StockMaterials.fetch(
        Object.assign({}, options, {
          stock_configure_flg: 1,
        })
      ).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.weightUnit = response.data.weightUnit;
            this.materialIdsArr = response.data.materialIdsArr;
            this.stock_materials = response.data.materials.map((item) => {
              let changedDetail = this.changedDetails.find(
                (s) => s.id == item.id
              );
              if (changedDetail) {
                return changedDetail;
              }
              return item;
            });
            this.getSavedStockMaterialsFromAPI();
            this.paging = response.data.paging;
          } else if (response.data.error.code.isNoResultSet()) {
            this.options.page = 1;
          }
        }.bind(this)
      );
    },
    saveNewStockMaterials() {
      this.$store.dispatch("fullscreenLoading");
      StockMaterials.saveNewStockMaterials({
        stock_id: this.stock_id,
        new_material_ids: this.addMaterials.map((d) => d.id),
      })
        .then(
          function (response) {
            if (response.data.status.isOK()) {
              this.getStockMaterialsFromAPI();
            }
            this.$store.dispatch("fullscreenLoadingStop");
          }.bind(this)
        )
        .catch(function () {
          this.$store.dispatch("fullscreenLoadingStop");
        });
    },
    submit() {
      this.$store.dispatch("fullscreenLoading");
      var submitData = [];
      this.changedDetails.forEach((detail) => {
        let data = {
          stock_id: this.stock_id,
          stock_area_id: detail.stock_area ? detail.stock_area.id : 0,
          stock_position_id: detail.stock_position
            ? detail.stock_position.id
            : 0,
          material_id: detail.material_id,
          stock_min: detail.stock_min ? detail.stock_min : 0,
          stock_max: detail.stock_max ? detail.stock_max : 0,
          pick_min: detail.pick_min ? detail.pick_min : 0,
          pick_max: detail.pick_max ? detail.pick_max : 0,
          status: detail.status,
          standard_detail_id: detail.standard_detail_id,
          peeling: detail.peeling,
        };
        if (!detail.new) data.id = detail.id;
        if (this.isWMS == 1) {
          data.prohibit_flg = detail.prohibit_flg ? detail.prohibit_flg : 0;
        } else if (this.isWMS == 2) {
          data.is_negative_allowed = detail.is_negative_allowed
            ? detail.is_negative_allowed
            : 0;
        }
        if (this.isWMS == 3) {
          data.prohibit_flg = detail.prohibit_flg ? detail.prohibit_flg : 0;
          data.is_negative_allowed = detail.is_negative_allowed
            ? detail.is_negative_allowed
            : 0;
        }

        submitData.push(data);
      });

      StockMaterials.saveStockMaterials(submitData)
        .then(
          function (response) {
            if (response.data.status.isOK()) {
              this.changedDetails = [];
              this.getStockMaterialsFromAPI();
            }
            this.$store.dispatch("fullscreenLoadingStop");
          }.bind(this)
        )
        .catch(function () {
          this.$store.dispatch("fullscreenLoadingStop");
        });
    },
    exportExcel() {
      var options = {
        stock_id: this.stock_id,
      };
      if (this.isWMS == 1) {
        //wms
        for (let key in this.options) {
          if (key != "is_negative_allowed") {
            options[key] = this.options[key];
          }
        }
      } else if (this.isWMS == 2) {
        //无wms
        for (let key in this.options) {
          if (key != "prohibit_flg") {
            options[key] = this.options[key];
          }
        }
      }
      if (this.isWMS == 3) {
        for (let key in this.options) {
          options[key] = this.options[key];
        }
      }
      StockMaterials.exports(options);
    },
    allSave() {
      this.$store.dispatch("fullscreenLoading");
      if (this.confirmType == 'batchUpdateUnitAsc' || this.confirmType == 'batchUpdateUnitDesc') {
        StockMaterials.updateMaterialUnit(this.stock_id, (this.confirmType == 'batchUpdateUnitAsc') ? {type: 1} : null).then(
          function (response) {
            if (response.data.status.isOK()) {
              this.$snackbar.success(i18n.t("StockMaterials.saveSuccess"));
              this.getStockMaterialsFromAPI();
              this.confirmMsg = "";
              this.confirmType = null;
            }
            this.$store.dispatch("fullscreenLoadingStop");
          }.bind(this)
        ).catch(function () {
          this.$store.dispatch("fullscreenLoadingStop");
        });
      } else {
        StockMaterials.allSave({
          stock_id: this.stock_id,
          materialIds: this.materialIdsArr,
          type: this.confirmType,
        }).then(
          function (response) {
            if (response.data.status.isOK()) {
              this.$snackbar.success(i18n.t("StockMaterials.saveSuccess"));
              this.getStockMaterialsFromAPI();
              this.confirmMsg = "";
              this.confirmType = null;
            }
            this.$store.dispatch("fullscreenLoadingStop");
          }.bind(this)
        ).catch(function () {
          this.$store.dispatch("fullscreenLoadingStop");
        });
      }
    },
    //获取已保存的商品
    getSavedStockMaterialsFromAPI() {
      var options = {
        stock_id: this.stock_id,
        readonly: 0,
        status: [1],
      };
      StockMaterials.fetch(
        Object.assign({}, options, {
          stock_configure_flg: 1,
        })
      ).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.weightUnit = response.data.weightUnit;
            this.savedMaterialIdsArr = response.data.materialIdsArr;
          } else if (response.data.error.code.isNoResultSet()) {
            this.options.page = 1;
          }
        }.bind(this)
      );
    },
    importExcel() {
      this.$store.dispatch("fullscreenLoading");
      StockMaterials.imports(this.stock_id, this.excelFile)
        .then(
          function (response) {
            if (response.data.status.isOK()) {
              this.$snackbar.info(
                i18n.t("Import.success", [
                  i18n.t("StockMaterials.importObjName"),
                ])
              );
              this.ImportDialog = false;
              this.getStockMaterialsFromAPI();
            }
            this.$store.dispatch("fullscreenLoadingStop");
          }.bind(this)
        )
        .catch(
          function () {
            this.$store.dispatch("fullscreenLoadingStop");
          }.bind(this)
        );
    },
  },

  watch: {
    isWMS: {
      immediate: true,
      deep: true,
      handler() {
        if (this.isWMS == 1) {
          //wms
          this.options = Object.assign({}, this.options, {
            prohibit_flg: [0],
          });
        } else if (this.isWMS == 2) {
          //无wms
          this.options = Object.assign({}, this.options, {
            is_negative_allowed: [0, 1],
          });
        }
        if (this.isWMS == 3) {
          this.options = Object.assign({}, this.options, {
            prohibit_flg: [0],
            is_negative_allowed: [0, 1],
          });
        }
      },
    },
    options: {
      // immediate: true, //为避免覆盖session里保存的options，不能启用immediate
      deep: true,
      handler() {
        this.getStockMaterialsFromAPI();
      },
    },
    categorySelecteds: {
      handler() {
        this.options.category_codes = this.categorySelecteds
          ? this.categorySelecteds.map((category) => {
              return category.code;
            })
          : "";
      },
    },
    stockAreaSelected: {
      handler() {
        this.options.stock_area_ids = this.stockAreaSelected
          ? this.stockAreaSelected.id
          : "";
      },
    },
    // 库位
    positionSelected: {
      handler() {
        this.options.stock_position_id = this.positionSelected
          ? this.positionSelected.id
          : null;
      },
    },
    usableAll: {
      handler() {
        this.stock_materials = this.stock_materials.map(
          function (detail) {
            detail.status = this.usableAll ? 1 : 0;
            detail.edit_status_flg = 1;
            return detail;
          }.bind(this)
        );
      },
    },
    prohibitAll: {
      handler() {
        this.stock_materials = this.stock_materials.map(
          function (detail) {
            detail.prohibit_flg = this.prohibitAll ? 1 : 0;
            detail.edit_prohibit_flg = 1;
            return detail;
          }.bind(this)
        );
      },
    },
    underZeroAll: {
      handler() {
        this.stock_materials = this.stock_materials.map(
          function (detail) {
            detail.is_negative_allowed = this.underZeroAll ? 1 : 0;
            detail.edit_is_negative_allowed = 1;
            return detail;
          }.bind(this)
        );
      },
    },
    stock_materials: {
      deep: true,
      handler() {
        this.stock_materials.forEach((detail) => {
          if (
            detail.edit_flg ||
            detail.edit_status_flg ||
            detail.edit_prohibit_flg ||
            detail.edit_is_negative_allowed
          ) {
            // 编辑模式下添加到已修改数组里
            let changedDetail = this.changedDetails.find(
              (s) => s.id == detail.id
            );
            if (!changedDetail) {
              this.changedDetails.push(detail);
            }
          }
        }); // 不管是新改变的还是原先就是有效状态的，都添加到changedDetails数组中
      },
    },
    addMaterials: {
      deep: true,
      handler() {
        // let newData = this.stock_materials.filter(
        //   (detail) => detail.new || !detail.id
        // );
        // if (this.addMaterials.length) {
        //   //过滤取消勾选的新商品
        //   newData.forEach((new_data) => {
        //     let del = this.addMaterials.find(
        //       (add_material) => add_material.id == new_data.material_id
        //     );
        //     if (typeof del == "undefined") {
        //       this.stock_materials.splice(
        //         this.stock_materials.findIndex(
        //           (stock_material) => stock_material.new == new_data.new
        //         ),
        //         1
        //       );
        //     }
        //   });
        //   //添加新勾选的商品
        //   this.addMaterials.forEach((material) => {
        //     let choosed = this.stock_materials.find(
        //       (stock_material) => stock_material.material_id == material.id
        //     );
        //     if (!choosed) {
        //       this.stock_materials.unshift({
        //         new: this.addMaterials.length + 1,
        //         edit_flg: 1,
        //         category_name: material.material_category
        //           ? material.material_category.name
        //           : "",
        //         material_id: material.id,
        //         material_name: material.material_name,
        //         material_code: material.material_code,
        //         standard_name: material.standard.name,
        //         standard: material.standard,
        //         unit: material.supply_standard_detail
        //           ? material.supply_standard_detail.unit
        //           : "",
        //         standard_detail_id: material.supply_standard_detail
        //           ? material.supply_standard_detail.id
        //           : "",
        //         standard_detail: material.supply_standard_detail,
        //         default_standard_detail: material.standard
        //           ? material.standard.default_standard_detail
        //           : "",
        //         stock_area: {
        //           id: 0,
        //           area_name: i18n.t("StockArea.noStockArea"),
        //         },
        //         status: 1,
        //         prohibit_flg: 0,
        //         is_negative_allowed: 1,
        //       });
        //     }
        //   });
        // } else {
        //   newData.forEach((new_data) => {
        //     this.stock_materials.splice(
        //       this.stock_materials.findIndex(
        //         (detail) => detail.new == new_data.new
        //       ),
        //       1
        //     );
        //   });
        // }
      },
    },
  },
};
</script>